var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSbomIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_7539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.645 20.1062C23.645 23.7755 20.7641 26.75 17.2104 26.75C13.6567 26.75 10.7759 23.7755 10.7759 20.1062C10.7759 16.437 13.6567 13.4624 17.2104 13.4624C20.7641 13.4624 23.645 16.437 23.645 20.1062Z",
    fill: "#6BCCEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6757 8.21695C14.6757 12.3408 11.4379 15.6839 7.44394 15.6839C3.44994 15.6839 0.212158 12.3408 0.212158 8.21695C0.212158 4.09307 3.44994 0.75 7.44394 0.75C11.4379 0.75 14.6757 4.09307 14.6757 8.21695Z",
    fill: "#EF3C76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2122 7.09215C26.2122 10.143 23.8407 12.6163 20.9154 12.6163C17.99 12.6163 15.6186 10.143 15.6186 7.09215C15.6186 4.04126 17.99 1.56802 20.9154 1.56802C23.8407 1.56802 26.2122 4.04126 26.2122 7.09215Z",
    fill: "#32BFAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8224 20.9088C10.7917 20.6457 10.7759 20.3779 10.7759 20.1062C10.7759 16.437 13.6567 13.4624 17.2104 13.4624C18.9602 13.4624 20.5469 14.1835 21.7068 15.3537C20.5986 18.8714 17.4122 21.4125 13.6544 21.4125C12.6612 21.4125 11.7079 21.235 10.8224 20.9088Z",
    fill: "#4D3280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44394 15.6839C11.4379 15.6839 14.6757 12.3408 14.6757 8.21695C14.6757 6.57669 14.1635 5.05963 13.2952 3.82765C8.78355 4.02303 5.18363 7.88302 5.18363 12.6161C5.18363 13.6066 5.34127 14.5588 5.63193 15.4472C6.21101 15.6015 6.81819 15.6839 7.44394 15.6839Z",
    fill: "#4D3280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3568 4.27714C19.6681 5.4339 22.0647 8.65785 22.1238 12.4717C21.7357 12.5662 21.3311 12.6163 20.9154 12.6163C17.99 12.6163 15.6186 10.143 15.6186 7.09215C15.6186 6.0641 15.8878 5.10148 16.3568 4.27714Z",
    fill: "#4D3280"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_7539"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0.212158 0.75)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbomIcon);
export default __webpack_public_path__ + "static/media/sbom-icon.81ae1ee4a13c393ac0d9babc2d7ceb6c.svg";
export { ForwardRef as ReactComponent };